import { render, staticRenderFns } from "./explainStop.vue?vue&type=template&id=0977f2e3&scoped=true&"
import script from "./explainStop.vue?vue&type=script&lang=js&"
export * from "./explainStop.vue?vue&type=script&lang=js&"
import style0 from "./explainStop.vue?vue&type=style&index=0&id=0977f2e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977f2e3",
  null
  
)

export default component.exports